import { SWITCH_LANG } from 'ACTIONS';

export const switchLang = lang => (dispatch) => {
    document.documentElement.setAttribute('lang', lang);
    dispatch({
        type: SWITCH_LANG,
        payload: lang
    });
};
